import * as React from 'react';
import * as _ from 'lodash';

import { Formatters } from '../../common/formatters';
import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';

export const RegionalComponentListDetailFormComponentDetailsRight = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleNoteDelete,
    handleNoteSave,
    handleSaveChanges,
    numFormChanges,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        colLabelXs: 3,
        colInputXs: 6,
        className: 'inventory-detail-input-full-width',
    });

    let inputPropsFullWidthOwnRow = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        colLabelXs: 12,
        colInputXs: 12,
    });

    const inputPropsTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    return (
        <DetailFormCommon.RegionalDetailFormSection title={sectionTitle}>
            <div>
                <div>
                    <KendoWrappers.KendoDropdownListInput
                        name="subgroup"
                        label="Subgroup"
                        textField="text"
                        valueField="value"
                        value={formData.subgroup}
                        data={formData.subgroupOptions}
                        allowCustom={false}
                        onChange={(o) => { handleFormInputChange({ target: { name: 'subgroup', type: 'kendo-dropdownlist', value: _.get(o, 'target.value') } }, o); }}
                        {...inputPropsFullWidth}
                    />
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="generalNote"
                        label="General Note"
                        rows={6}
                        cols={40}
                        value={Formatters.getStr(formData, 'generalNote')}
                        {...inputPropsTextAreaDebounced}
                    />
                </div>
            </div>
        </DetailFormCommon.RegionalDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/regional-component-lists/detail-form/component-details-right.tsx